import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";

export const base_url = process.env.REACT_APP_BASE_URL;
export const api_type = process.env.REACT_APP_API_TYPE;

const Repeater = ({ rows, setRows, bondDetails }) => {
  const handleAddRow = () => {
    setRows([...rows, { name: "", id: null, quantity: "", suggestions: [] }]);
  };

  const handleRemoveRow = (index) => {
    const updated = [...rows];
    updated.splice(index, 1);
    setRows(updated);
  };

  const handleInputChange = (index, field, value) => {
    const updated = [...rows];
    updated[index][field] = value;

    if (field === "name") {
      updated[index].id = null;
      setRows(updated); // show typed name immediately
      fetchNameSuggestions(index, value);
    } else {
      setRows(updated);
    }
  };

  const fetchNameSuggestions = async (index, query = "") => {
    // if (!query.trim()) return;

    try {
      const response = await axios.get(
        `${base_url}/${api_type}/bonds/getUsers?search=${query}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      const users = response?.data?.data?.users || [];

      console.log("users", users);
      if (query) {
        console.log("rows inside quey", rows);
        // Exclude already-selected IDs
        const selectedIds = rows?.map((r) => r.userId).filter(Boolean);
        console.log("selectedIds", selectedIds);
        const filteredSuggestions = users?.filter(
          (user) => !selectedIds.includes(user.id)
        );

        console.log("filteredSuggestions", filteredSuggestions);

        const updated = [...rows];
        updated[index].suggestions = filteredSuggestions;
        setRows(updated);
      } else {
        const transformedRows = rows?.map((row) => {
          console.log("inside else row", row);
          const user = users?.find((u) => u.id === row.userId);
          console.log("inside else user", user);
          return {
            id: row.id || null,
            name: user ? user?.name : "",
            userId: row?.userId,
            bondId: row?.bondId,
            quantity: row?.quantity || "",
            suggestions: [],
          };
        });
        setRows(transformedRows);
        console.log("transformedRows", transformedRows);
      }
    } catch (error) {
      console.error("Error fetching names:", error);
    }
  };

  const handleSelectSuggestion = (index, suggestion) => {
    const isDuplicate = rows.some(
      (r, i) => r.id === suggestion.id && i !== index
    );

    if (isDuplicate) {
      toast.info("This user is already selected in another row.");
      return;
    }

    console.log("suggestion", suggestion);

    const updated = [...rows];
    updated[index].name = suggestion.name;
    updated[index].userId = suggestion.id;
    updated[index].suggestions = [];
    setRows(updated);
  };

  useEffect(() => {
    fetchNameSuggestions();
  }, [bondDetails]);

  return (
    <div className="space-y-6">
      {rows.map((row, index) => (
        <div key={index} className="flex items-start space-x-4 relative">
          {/* Name Field */}
          <div className="flex-1">
            <label className="block text-sm font-medium text-gray-700">
              Select Investor
            </label>
            <div className="w-full flex gap-3 justify-start items-center">
              <label>{index + 1}.</label>
              <input
                type="text"
                value={row.name}
                onChange={(e) =>
                  handleInputChange(index, "name", e.target.value)
                }
                className="mt-1 block w-full border border-gray-300 rounded-md p-2"
                placeholder="Search by name"
                autoComplete="off"
              />
              {row?.suggestions?.length > 0 && (
                <ul className="absolute z-10 bg-white border border-gray-300 mt-1 rounded shadow text-sm max-h-32 overflow-auto w-full">
                  {row.suggestions.map((s) => (
                    <li
                      key={s.id}
                      className="px-2 py-1 hover:bg-gray-100 cursor-pointer"
                      onClick={() => handleSelectSuggestion(index, s)}
                    >
                      {s.name}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>

          {/* Quantity Field */}
          <div className="w-32">
            <label className="block text-sm font-medium text-gray-700">
              Quantity
            </label>
            <input
              type="number"
              min="1"
              value={row.quantity}
              onChange={(e) =>
                handleInputChange(index, "quantity", e.target.value)
              }
              //   onBlur={(e) => {
              //     const value = parseInt(e.target.value, 10);
              //     if (!value || value < 1) {
              //       handleInputChange(index, "quantity", 1); // force minimum value
              //     }
              //   }}
              className="mt-1 block w-full border border-gray-300 rounded-md p-2"
              placeholder="Qty"
            />
          </div>

          {/* Remove Button */}
          {rows?.length > 0 && (
            <button
              onClick={() => handleRemoveRow(index)}
              className="mt-6 text-red-600 hover:text-red-800 text-sm"
            >
              Remove
            </button>
          )}
        </div>
      ))}

      {/* Add Button */}
      <button
        onClick={() => handleAddRow()}
        className="bg-[#0066b2] text-white px-4 py-2 rounded "
      >
        Add {rows?.length < 1 ? `New Investor` : `More`}
      </button>

      {/* Debug Output */}
      {/* <pre className="mt-4 bg-gray-100 p-2 text-xs overflow-auto">
        {JSON.stringify(rows, null, 2)}
      </pre> */}
    </div>
  );
};

export default Repeater;
